/** Parse DRF paginated responses consistently across list pages. */
export function parsePaginated(res) {
  const data = res?.data ?? res;
  const results = Array.isArray(data?.results)
    ? data.results
    : Array.isArray(data)
      ? data
      : [];
  return {
    results,
    count: typeof data?.count === 'number' ? data.count : results.length,
    next: data?.next ?? null,
    previous: data?.previous ?? null,
  };
}

export const LIST_PAGE_SIZES = [12, 24, 48];
export const DEFAULT_LIST_PAGE_SIZE = 24;

export function totalPages(count, pageSize) {
  return Math.max(1, Math.ceil((count || 0) / pageSize));
}

export function pageRange(page, total, siblingCount = 1) {
  const start = Math.max(1, page - siblingCount);
  const end = Math.min(total, page + siblingCount);
  const pages = [];
  for (let i = start; i <= end; i += 1) pages.push(i);
  return pages;
}
